import { render, staticRenderFns } from "./NiqInter.vue?vue&type=template&id=41923d9c&"
import script from "./NiqInter.vue?vue&type=script&lang=js&"
export * from "./NiqInter.vue?vue&type=script&lang=js&"
import style0 from "./NiqInter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports